import React from 'react';
import _ from 'lodash';
import platform from 'platform';

/*
	TODO: need to make a copy of the experiment so the _meta does not change original.
	Auto advance applies to direct children only.
	0 will disable it.
	Need to fix the expiring token. 
	When deleting, make sure you take it out of the current screen.
*/

export default class LiveExperiment{
	constructor(app, component){
		this.app = app;
		this.component = component;
		this.reset();
		this.next = this.next.bind(this);
	}

	reset(){
		this.data = {};
		this.response = [];
		this.groupAutoAdvance = 0;
		this.occurenceMap = {};
	}

	start(){
		this.currentScreen = this.data.screens;
		let now = Date.now();
		this.counter = 0;
		this.eventCounter = 0;
		this.experimentStartTime = now;
		this.groupStartTime = now;
		this.screenStartTime = now;
		this.lastActionStartTime = now;
		this.executeScreen();
	}

	next(){
		if(this.cancelled){ return; }
		this.recordEvent({eventType:'Screen Finish', screenId:this.currentScreen.id });
		this.currentScreen = this.getNextScreenOrParent(this.currentScreen);
		this.executeScreen();
	}

	cleanup(){
		clearTimeout(this.overallTimeout);
		clearTimeout(this.currentScreenTimeout);
	}

	get timeSinceStart(){ return Date.now() - this.experimentStartTime; }
	get timeSinceGroup(){ return Date.now() - this.groupStartTime; }
	get timeSinceScreen(){ return Date.now() - this.screenStartTime; }
	get timeSinceLastAction(){ let time = Date.now() - this.lastActionStartTime; this.lastActionStartTime = Date.now();  return time;}

	get currentParent(){ return (this.currentScreen && this.currentScreen.parents) ? this.currentScreen.parents[0] : undefined; }
	get currentRow(){ return  this.currentParent ? this.currentParent._meta.rows[this.currentParent._meta.loopCount] : {}; }

	get flattenedResponse(){
		return this.response.map( item => {
			if(!item.rows){ return item; }

			const clone = {...item};
			clone.rows.forEach( (row, index) => {
				
				_.each(row, (rowItem, key) => {
					clone[`row[${index+1}]${key}`] = rowItem;
				});
			});
			delete clone.rows;
			return clone;
		});
	}

	getEnvironmentDetails(){
		return {
			viewportWidth: window.innerWidth,
			viewportHeight: window.innerHeight,
			deviceScreenWidth: window.screen.width,
			deviceScreenHeight: window.screen.height,
			browser: platform.name,
			browserVersion: platform.version,
			os: platform.os.family,
			osVersion: platform.os.version,
		};
	}

	recordEvent(details){

		this.eventCounter++;

		//let fullStructurePath = this.structurePath + '/' + _.get(this.currentScreen, 'id', '') + '/' + details.elementId

		let idPath = this.currentIDPath;

		if(_.has(details, 'value')){
			this.currentRow[ 'response.' +  _.get(this.currentScreen, 'id', '') + '/' + details.elementId ] = details.value;
			idPath = idPath + '/' + details.elementId;
		}

		if(_.has(details, 'expectedValue')){
			this.currentRow[ 'response.' +  _.get(this.currentScreen, 'id', '') + '/' + details.elementId + "/expectedValue" ] = details.expectedValue;
		}

		let occurenceKey = `${this.currentPath}/${details.eventType}/${details.actionType}`;
		this.occurenceMap[occurenceKey] = this.occurenceMap[occurenceKey] || 0;
		this.occurenceMap[occurenceKey]++

		let timestamp = Date.now();
		let timings = {
			timeSinceStart: this.timeSinceStart,
			timeSinceGroup: this.timeSinceGroup,
			timeSinceScreen: this.timeSinceScreen,
			timeSinceLastAction: this.timeSinceLastAction,
		};

		let row = this.currentRow || {};
		let rowValues = {};
		Object.keys(row).forEach( key => {
			rowValues['row_'+key] = row[key];
		});

		//TODO You could add all the values from the screen right here.

		let {eventType, actionType, screenId, elementId, elementType, value, expectedValue, ...leftOverDetails} = details;


		let groupPath = this.structurePath;
		if (this.currentScreen && this.currentScreen.isGroup ){
			groupPath += '/' + this.currentScreen.id;
		}


		this.response.push({
			timestamp,
			eventIndex:this.eventCounter,
			presentationScreenIndex:this.counter,
			eventType,
			actionType,
			group: groupPath,
			screenId,
			elementId,
			elementType,
			value,
			expectedValue,
			...leftOverDetails,
			occurenceIndex: this.occurenceMap[occurenceKey],
			...timings,
			presentationPath: this.currentPath,
			idPath: idPath,
			...rowValues,
		});

	}

	executeScreen(){
		clearTimeout(this.currentScreenTimeout);
		let screen = this.currentScreen;

		//console.log('Screen', screen);
		this.counter++;
		

		// FINISHED
		if(!screen){
			this.currentIDPath = '';
			this.currentPath = '';
			this.structurePath = '';
			this.recordEvent({eventType:'Finish'});
			this.finish();
			return;
		}

		let parents = LiveExperiment.getScreenParents(screen, this.data.screens) || [];
		parents.reverse();
		this.currentPath = parents.map(parent => {
			return `${parent.id}[${parent._meta.loopCount + 1}]`;
		}).join('/') + '/' + screen.id;


		this.currentIDPath = parents.map(parent => {
			return `${parent.id}[${parent._meta.currentRow.id || 0}]`;
		}).join('/') + '/' + screen.id;

		this.structurePath = parents.map(parent => {
			return `${parent.id}`;
		}).join('/');


		// INDVIDUAL SCREEN
		if(!screen.isGroup){
			
			screen.parents = parents.reverse();

			screen.elements = screen.elements || [];
			screen._parsedElements = screen.elements.map( element => {
				let elementClone = _.cloneDeep(element);
				this.replaceProperties(elementClone);
				return elementClone;
			})



			this.recordEvent({eventType:'Screen Load', screenId:screen.id });
			this.screenStartTime = Date.now();

			if(screen.autoAdvance !== 0 && screen.autoAdvance !== '0'){ // If screenAutoAdvance === 0, then we don't need to do anything.
				const autoAdvance = screen.autoAdvance || screen.parents[0].autoAdvance;
				if(autoAdvance){
					this.currentScreenTimeout = setTimeout(this.next, autoAdvance * 1000);
				}
			}

			this.forceUpdate();
			return;
		}

		// GROUP SCREEN
		this.initGroupIfFirstTime(screen);

		// We have been through at least once
		if(screen._meta.loopCount > 0 ){
			if(screen._meta.loopCount >= screen._meta.rows.length){
				// There are no more rows to show.
				this.currentScreen = this.getNextScreenOrParent(screen);
				this.executeScreen();
				return;
			}
		}

		if(screen.randomizeChildren){
			screen.children = _.shuffle(screen.children);
		}

		this.groupAutoAdvance = screen.autoAdvance;

		if(screen.overallTimeLimit){
			console.log('setting for ', screen.overallTimeLimit * 1000 * 60);
			this.overallTimeout = setTimeout(this.finishViaTimeout.bind(this), screen.overallTimeLimit * 1000 * 60);
		}


		this.currentScreen = screen.children[0];
		this.executeScreen();
	}

	initGroupIfFirstTime(screen){
		if(screen._meta){
			screen._meta.loopCount++;

			// Reset everything inside the group.
			if(screen.children){
				screen.children.forEach( child =>{
					if(child._meta){
						child._meta = undefined;
					}
				});
			}


			return;
		}

		screen._meta =  {
			loopCount:0,
			rows:[{}],
			get currentRow(){
				return this.rows[this.loopCount];
			}
		}

		if(screen.useDataSet && screen.dataSetId){
			let dataSet = this.data.dataSets.find(dataSet => dataSet.id === screen.dataSetId);
			if(dataSet){
				
				let rows = [...dataSet.rows];

				let parsedRows = rows.map( row => _.zipObject(rows[0], row)).slice(1);

				//console.log('parsedRows', parsedRows);

				screen._meta.rows = parsedRows;

				if(screen.randomizeDataSet){
					screen._meta.rows = _.shuffle(screen._meta.rows);
				}
				if(screen.dataSetRowLimit){
					screen._meta.rows.splice(screen.dataSetRowLimit);
				}


			}
		}

		this.recordEvent({eventType:'Group Change', rows:screen._meta.rows  });
		this.groupStartTime = Date.now();
	}

	finishViaTimeout(){
		this.currentPath = '';
		this.currentIDPath = '';
		this.structurePath = '';
		this.recordEvent({eventType:'Overall Timeout'});
		this.finish({title:'This experiment has reached the maximum allowed time.'});
	}

	async finish({title = 'You finished!', message = 'Thank you for your participation. Your responses have been saved.'} = {}){

		this.cleanup();

		let environment = this.getEnvironmentDetails()

		let data = {responseData:this.flattenedResponse, environment};

		if(!this.app.liveExperiment.preview){
			let result = await this.app.takeExperimentForm.submit(data);
			if(!result){
				return;
			}
		}else{
			console.log(JSON.stringify(data, null, '\t'));
		}
	
		this.app.openDialog({
			label:title,
			Component:() => (
			<div>
				{message}
				{ !!this.app.liveExperiment.preview &&
					<div style={{marginTop:'20px'}}>Note: Since this a preview, your response was not saved.</div>
				}
			</div>),
			afterClose: () => {
				if(this.app.liveExperiment.preview){
					this.app.closeFullScreenDialog();
				}
				if(!this.app.liveExperiment.preview){
					this.app.history.push('/experiments');
				}
			},
		});
	}

	forceUpdate(){
		if(!this.component){return;}
		this.component.forceUpdate();
	}

	replaceValues(str){
		let media = window.indexedFiles;
		const o = {
			row: this.currentRow,
			media: media,
		};
		
		return replaceValues(str, (value) => {
			return _.get(o, value);
		});
	}

	replaceProperties(container){
		_.forEach(container, (o,k) => {
			if(_.isString(o)){
				container[k] = this.replaceValues(o);
			} else if(_.isArray(o)){
				this.replaceProperties(o);
			}else if(_.isNumber(o)){

			}
		});
	}



	getScreenParents(screen){ return this.constructor.getScreenParents(screen, this.data.screens); }
	getScreenParent(screen){ return this.constructor.getScreenParent(screen, this.data.screens); }

	getNextScreenOrParent(screen){
		let parent = this.getScreenParent(screen);
		if(!parent){
			return null;
		}
		let index = parent.children.indexOf(screen);
		
		// There is a next sibling. Return it.
		if(index !== parent.children.length - 1){
			return parent.children[index + 1];
		}

		return parent;
	}
}

// Returns an array of the parents [parent, grandparent, greatgreatparent]
LiveExperiment.getScreenParents = function(screen, rootNode){
	
	const getParent = (node, parents) =>{
		if(!_.isArray(node.children)){return;}
		if(node.children.includes(screen)){
			return parents;
		}
		return _.compact(node.children.map( child => getParent(child, [child, ...parents]) ))[0];
	}

	const parents = getParent(rootNode, [rootNode]);
	return parents;
}

LiveExperiment.getScreenParent = function(screen, rootNode){
	const getParent = (node) =>{
		if(!_.isArray(node.children)){return;}
		if(node.children.includes(screen)){
			return node;
		}
		return _.compact(node.children.map( child => getParent(child) ))[0];
	}

	const parent = getParent(rootNode);
	return parent;
}


// LiveExperiment.getScreenParent = function(screen, rootNode){
// 	const [parent] = LiveExperiment.getScreenParents(screen, [rootNode]) || [];
// 	return parent;
// }

function replaceValues(str, o) {
	return str.replace(/{([^{}]*)}/g, function (original, inner) {
		var r = o(inner);
		return typeof r === 'string' || typeof r === 'number' ? r : original;
	});
}


// WEBPACK FOOTER //
// ./src/models/LiveExperiment.js